/**
 * Portal ICAVI - Serviço de domínio: Aluguel de Carros (Compras + SAC)
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 *
 * Agrupa os dois módulos que compartilham os tipos de SolicitacaoAluguelCarro:
 *   - Compras → /api/compras/aluguel-carros/*
 *   - SAC     → /api/sac/reservas-carros/*
 */
import axios from 'axios';
import { api } from '../apiClient';
// ---- Métodos ----------------------------------------------------------------
export const aluguelCarrosServiceMethods = {
    // ------ Compras - Aluguel de Carros ----------------------------------------
    async listarSolicitacoesAluguelCarros(params) {
        try {
            const response = await api.get('/api/compras/aluguel-carros/solicitacoes', { params });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar solicitações de aluguel de carros:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async listarColaboradoresAluguelCarros(params) {
        try {
            const response = await api.get('/api/compras/aluguel-carros/colaboradores-elegiveis', { params });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar colaboradores elegíveis para aluguel de carros:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async listarSolicitacoesManuaisAluguelCarros(params) {
        try {
            const response = await api.get('/api/compras/aluguel-carros/solicitacoes-manual', { params });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar solicitações manuais de aluguel de carros:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async criarSolicitacaoManualAluguelCarro(dados) {
        try {
            const response = await api.post('/api/compras/aluguel-carros/solicitacoes-manual', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao criar solicitação manual de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async atualizarSolicitacaoManualAluguelCarro(solicitacaoId, dados) {
        try {
            const response = await api.put(`/api/compras/aluguel-carros/solicitacoes-manual/${solicitacaoId}`, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar solicitação manual de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async confirmarSolicitacaoManualAluguelCarro(solicitacaoId) {
        try {
            const response = await api.post(`/api/compras/aluguel-carros/solicitacoes-manual/${solicitacaoId}/confirmar`, {}, { headers: { 'Content-Type': 'application/json' } });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao confirmar solicitação manual de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            return {
                sucesso: false,
                mensagem: error?.message || 'Erro ao confirmar solicitação',
                dados: null,
            };
        }
    },
    async excluirSolicitacaoManualAluguelCarro(solicitacaoId) {
        try {
            const response = await api.delete(`/api/compras/aluguel-carros/solicitacoes-manual/${solicitacaoId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir solicitação manual de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    /** Solicitante pede o cancelamento; o Compras confirma depois. */
    async cancelarSolicitacaoManualAluguelCarro(solicitacaoId, motivo) {
        try {
            const response = await api.post(`/api/compras/aluguel-carros/solicitacoes-manual/${solicitacaoId}/cancelar`, { motivo: motivo?.trim() || null });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao solicitar cancelamento de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async prorrogarSolicitacaoManualAluguelCarro(solicitacaoId, nova_data_devolucao, motivo, local_devolucao, km_adicional) {
        try {
            const response = await api.post(`/api/compras/aluguel-carros/solicitacoes-manual/${solicitacaoId}/prorrogar`, {
                nova_data_devolucao,
                motivo,
                local_devolucao: local_devolucao || undefined,
                km_adicional,
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao prorrogar solicitação manual de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    /** Compras confirma o cancelamento solicitado (solicitação passa a cancelada). */
    async confirmarCancelamentoManualAluguelCarro(solicitacaoId) {
        try {
            const response = await api.post(`/api/compras/aluguel-carros/solicitacoes-manual/${solicitacaoId}/confirmar-cancelamento`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao confirmar cancelamento de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async confirmarProrrogacaoManualAluguelCarro(solicitacaoId, observacao) {
        try {
            const response = await api.post(`/api/compras/aluguel-carros/solicitacoes-manual/${solicitacaoId}/confirmar-prorrogacao`, observacao ? { observacao } : {});
            return response.data;
        }
        catch (error) {
            console.error('Erro ao confirmar prorrogação manual de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async obterSolicitacaoAluguelCarro(id) {
        try {
            const response = await api.get(`/api/compras/aluguel-carros/solicitacoes/${id}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao obter solicitação de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async obterSolicitacaoAluguelPorProgramacao(programacaoId) {
        try {
            const response = await api.get(`/api/compras/aluguel-carros/programacoes/${programacaoId}/solicitacao`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao obter solicitação de aluguel por programação:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async atualizarStatusAluguelCarro(id, dados, origem = 'sac') {
        try {
            const url = origem === 'manual'
                ? `/api/compras/aluguel-carros/solicitacoes-manual/${id}/status`
                : `/api/compras/aluguel-carros/solicitacoes/${id}/status`;
            const response = await api.put(url, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar status de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async uploadAnexoAluguelCarro(id, arquivo, tipo, origem = 'sac') {
        try {
            const formData = new FormData();
            formData.append('arquivo', arquivo);
            if (tipo)
                formData.append('tipo', tipo);
            const url = origem === 'manual'
                ? `/api/compras/aluguel-carros/solicitacoes-manual/${id}/upload`
                : `/api/compras/aluguel-carros/solicitacoes/${id}/upload`;
            const response = await api.post(url, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao enviar anexo de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async excluirAnexoAluguelCarro(anexoId) {
        try {
            const response = await api.delete(`/api/compras/aluguel-carros/anexos/${anexoId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir anexo de aluguel de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async downloadAnexoManualAluguelCarro(anexoId) {
        try {
            const response = await api.get(`/api/compras/aluguel-carros/anexos/${anexoId}/download`, { responseType: 'blob' });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao baixar anexo manual de aluguel de carro:', error);
            throw error;
        }
    },
    // ------ SAC - Reservas de Carros ------------------------------------------
    async listarReservasCarros(params = {}) {
        try {
            const response = await api.get('/api/sac/reservas-carros', { params });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar reservas de carros do SAC:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async obterReservaCarro(programacaoId) {
        try {
            const response = await api.get(`/api/sac/reservas-carros/${programacaoId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao obter detalhes da reserva de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async salvarReservaCarro(programacaoId, dados) {
        try {
            const response = await api.put(`/api/sac/reservas-carros/${programacaoId}`, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao salvar rascunho da reserva de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async confirmarReservaCarro(programacaoId) {
        try {
            const response = await api.post(`/api/sac/reservas-carros/${programacaoId}/confirmar`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao confirmar reserva de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async uploadCnhReservaCarro(programacaoId, arquivo) {
        try {
            const formData = new FormData();
            formData.append('arquivo', arquivo);
            const response = await api.post(`/api/sac/reservas-carros/${programacaoId}/upload-cnh`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao enviar CNH da reserva de carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async downloadArquivoObra(arquivoId) {
        try {
            const response = await api.get(`/api/sac/fechamento-obras/arquivos/${arquivoId}/download`, { responseType: 'blob' });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao baixar arquivo de obra:', error);
            throw error;
        }
    },
};
